export const version: string = '0.5.7';
